import OnboardCandidateProfile from "./onboardCandidateProfile";
export default OnboardCandidateProfile;